var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCactus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 30.375H30.375",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 30.375V18.5625H11.8125C9.57474 18.5625 7.42862 17.6736 5.84629 16.0912C4.26395 14.5089 3.375 12.3628 3.375 10.125V10.125C3.3787 9.38022 3.6762 8.66699 4.20285 8.14035C4.72949 7.6137 5.44272 7.3162 6.1875 7.3125C6.93228 7.3162 7.64551 7.6137 8.17215 8.14035C8.6988 8.66699 8.9963 9.38022 9 10.125C9.0037 10.8698 9.3012 11.583 9.82785 12.1097C10.3545 12.6363 11.0677 12.9338 11.8125 12.9375H13.5V7.875C13.5 6.68153 13.9741 5.53693 14.818 4.69302C15.6619 3.84911 16.8065 3.375 18 3.375V3.375C19.1935 3.375 20.3381 3.84911 21.182 4.69302C22.0259 5.53693 22.5 6.68153 22.5 7.875V18.5625H24.1875C24.9323 18.5588 25.6455 18.2613 26.1722 17.7347C26.6988 17.208 26.9963 16.4948 27 15.75V15.75C27.0037 15.0052 27.3012 14.292 27.8278 13.7653C28.3545 13.2387 29.0677 12.9412 29.8125 12.9375C30.5573 12.9412 31.2705 13.2387 31.7972 13.7653C32.3238 14.292 32.6213 15.0052 32.625 15.75V15.75C32.625 17.9878 31.7361 20.1339 30.1537 21.7162C28.5714 23.2986 26.4253 24.1875 24.1875 24.1875H22.5V30.375",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCactus);
export default __webpack_public_path__ + "static/media/cactus.3066e205cfc25759593c51ea55abba41.svg";
export { ForwardRef as ReactComponent };